module.exports = __webpack_public_path__ + "img/FPC.1145bc32.png";